export const baseUrl = 'https://partful.io';

/* Legacy URLs */
export const legacyPrivacy = `${baseUrl}/privacy`;
export const legacyTerms = `${baseUrl}/terms`;

/* Partful Next Gen URLs */

// Knowledge base
export const knowledgeBase = `${baseUrl}/knowledge`;

export const salesBomPartsMatching = `${knowledgeBase}/how-to-sales-boms-and-parts-matching`;
export const acceptedFileFormats = `${knowledgeBase}/accepted-file-formats-for-uploads`;
export const cadExportInstructions = `${knowledgeBase}/how-to-export-cad`;
export const kitsLearnMore = `${knowledgeBase}/creating-your-3d-electronic-parts-catalog#kits`;

// Support
export const raiseTicket = `${baseUrl}/support`;

// Legal
export const privacyPolicy = 'https://sites.google.com/samsonvt.com/partful/privacy-policy';
export const licenseAgreement = 'https://sites.google.com/samsonvt.com/partful/licence-agreement';
